<div class="tag_dashboard_container m-2">

    <!-- Header with title -->
    <div class="header_bar m_inline-2 g-10">
        <div class="throughput_title w-100">
            <span class="f-m">Live Temperature Monitoring</span>
            <hr class="m-0 title_border">
        </div>
    </div>

    <!-- Live Tracking Summary Card -->
    <div class="tracking_summary_container mt-3 m-2" *ngIf="trackingData && trackingData.length">
        <div class="tracking_card p-3 bg-white rounded">
            <div class="tracking_item" *ngFor="let item of trackingData">
                <span class="t_label text-muted">{{ item.label }}</span>
                <span class="t_val f-sb" 
                      [ngClass]="item.valueClass || ''" 
                      [ngStyle]="item.style ? {'font-size': '13px'} : {}">
                    {{ item.value }}
                    <span *ngIf="item.subValue" class="t_card_time ml-1">
                        ({{ item.subValue }})
                    </span>
                </span>
            </div>
        </div>
    </div>

    <!-- Live Tag Cards Grid -->
    <div class="tags_grid mt-3 m-2">
        <ng-container *ngFor="let tag of tagList; let i = index">
            <div class="tag_card">
                <div class="card_content">
                    <!-- Card Header: Title -->
                    <div class="tag_header">
                        <span class="tag_title text-truncate" [matTooltip]="tag.title">{{ tag.title }}</span>
                    </div>

                    <!-- Live Value -->
                    <div class="tag_value_container">
                        <span class="tag_value" [ngClass]="{'alert_text': tag.isAlert}">
                            {{ tag.value !== '--' ? (tag.value | number:'1.0-2') : '--' }}
                        </span>
                        <span class="tag_unit" [ngClass]="{'alert_text': tag.isAlert}">{{ tag.unit }}</span>
                    </div>

                    <!-- Timestamp Footer -->
                    <div class="tag_footer">
                        <i class="fa fa-clock-o mr-1"></i>
                        <span *ngIf="tag.timestamp">{{ tag.timestamp }}</span>
                        <span *ngIf="!tag.timestamp">No Data</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

</div>